module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=''+
((__t=(potencyText))==null?'':__t)+
'\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/potency-display/potency-display.html
 ** module id = 99
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 14 16 17 22 25 26 29 31 37 49 171
 **/